/**
 * Node Modules
 */
import React, { useEffect, useState } from 'react'

/**
 * Application Modules
 */
import './style.css'
import Section from '../../../components/section'
import Spacer from '../../../components/spacer'

function TeamPhotos({list, active = false}) {
  return (
    <div className={`our-team-team__list ${active ? 'active': ''}`}>
      {
        list.map(member => (
          <div key={member.name} className="our-team-team__member">
            <img
              loading="eager"
              className="our-team-team__photo"
              src={member.photo.file.url}
              alt={member.photo.title}
            />
            <div className="our-team-team__member-copy">
              <Spacer size={[10, 20]} />
              <span className="our-team-team__name">{member.name}</span>
              <span className="our-team-team__title">{member.title}</span>
              <Spacer size={[26, 60]} />
            </div>
          </div>
        ))
      }
    </div>
  )
}

/**
 * Component
 */
export default function OurTeam({ leadershipTeam, creativeTeam, techTeam, customerTeam }) {
  const [activeSubGroup, setActiveSubGroup] = useState(0)

  return (
    <Section className="our-team-team" id="our-team">
      <div className="grid">
        <div className="column-start-1 column-end-6 column-end-12--t">
          <div className="our-team-team__categories">
            <div>
              <button
                className={`our-team-team__button reset ${activeSubGroup === 0 ? 'active': ''}`}
                onClick={() => {setActiveSubGroup(0)}}
              >Leadership</button>
              <span aria-hidden>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            </div>

            <div>
              <button
                className={`our-team-team__button reset ${activeSubGroup === 1 ? 'active': ''}`}
                onClick={() => {setActiveSubGroup(1)}}
              >Creative</button>
              <span aria-hidden>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            </div>

            <div>
              <button
                className={`our-team-team__button reset ${activeSubGroup === 2 ? 'active': ''}`}
                onClick={() => {setActiveSubGroup(2)}}
              >Tech</button>
              <span aria-hidden>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            </div>

            <button
              className={`our-team-team__button reset ${activeSubGroup === 3 ? 'active': ''}`}
              onClick={() => {setActiveSubGroup(3)}}
            >Customer</button>
          </div>

          <Spacer size={[30, 60]} />

          <div className="our-team-team__container">

            <TeamPhotos list={leadershipTeam} active={activeSubGroup === 0} />
            <TeamPhotos list={creativeTeam} active={activeSubGroup === 1} />
            <TeamPhotos list={techTeam} active={activeSubGroup === 2} />
            <TeamPhotos list={customerTeam} active={activeSubGroup === 3} />

          </div>
        </div>
      </div>
      <Spacer size={[25, 80]} />
    </Section>
  )
}
